import apiClient from "./client";
import type { Speaker } from "@/types";

export const speakersApi = {
  list: (params?: Record<string, string>): Promise<Speaker[]> =>
    apiClient.get("/speakers", { params }).then(r => r.data),

  get: (id: string): Promise<Speaker> =>
    apiClient.get(`/speakers/${id}`).then(r => r.data),

  create: (data: Partial<Speaker>): Promise<Speaker> =>
    apiClient.post("/speakers", data).then(r => r.data),

  update: (id: string, data: Partial<Speaker>): Promise<Speaker> =>
    apiClient.patch(`/speakers/${id}`, data).then(r => r.data),

  delete: (id: string): Promise<void> =>
    apiClient.delete(`/speakers/${id}`).then(r => r.data),

  import: (rows: Record<string, string>[]): Promise<{ created: number; skipped: number; skippedEmails: string[] }> =>
    apiClient.post("/speakers/import", { rows }).then(r => r.data),

  suggest: (params?: { tags?: string; excludeSessionId?: string }): Promise<Speaker[]> =>
    apiClient.get("/speakers/suggest", { params }).then(r => r.data),

  uploadPhoto: (id: string, file: File): Promise<{ photoUrl: string }> => {
    const fd = new FormData();
    fd.append("photo", file);
    return apiClient.post(`/speakers/${id}/photo`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then(r => r.data);
  },
};
